// extracted by mini-css-extract-plugin
export default {"box":"TriangleElem_box__ACAv8","top":"TriangleElem_top__mFZSF","triangle":"TriangleElem_triangle__gShtE","bottom":"TriangleElem_bottom__r4eXj"};